import { render, staticRenderFns } from "./connectionDetails.vue?vue&type=template&id=323d4ace"
import script from "./connectionDetails.ts?vue&type=script&lang=js&external"
export * from "./connectionDetails.ts?vue&type=script&lang=js&external"
import style0 from "./connectionDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports